import { Injectable } from '@angular/core';
declare let gtag: Function;
declare let fbq: Function;

@Injectable({
  providedIn: 'root'
})
export class GaService {

  public emitEvent(eventAction: string, screenName: string) {
    this.trackEvent(eventAction, {
      app_name: 'FINKFCCHRISTMAS26',
      screen_name: screenName
    });
  }

  trackEvent(eventName: string, params: Record<string, unknown> = {}): void {
    if (typeof window === 'undefined') {
      return;
    }
    const gtagFn = (window as any).gtag;
    if (typeof gtagFn !== 'function') {
      return;
    }
    gtagFn('event', eventName, params);
  }
}
